import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CoffeeMakerIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CoffeeMakerIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M20.249 6.7295H18.3582L14.2459 4.98396L14.4274 2.95162C14.4394 2.8171 14.3937 2.68322 14.303 2.5836C14.2123 2.48398 14.0828 2.42688 13.9477 2.42688H11.6425C11.5074 2.42688 11.3779 2.48399 11.2872 2.5836C11.1964 2.68258 11.1508 2.81647 11.1628 2.95162L11.3443 4.98967L7.40142 6.7295H6.41729C4.8805 6.7295 3.62988 7.98012 3.62988 9.51691V12.2066C3.62988 12.8957 4.19079 13.4566 4.8805 13.4566C5.56958 13.4566 6.13049 12.8957 6.13049 12.2066V9.51691C6.13049 9.36145 6.26183 9.23074 6.41729 9.23074H7.36969L8.18123 13.8272C8.25674 14.2593 8.55686 14.56 8.94138 14.6038V15.9566C8.57019 15.9978 8.28529 16.2783 8.18568 16.7085L7.03277 21.704C7.00041 21.8474 7.03404 21.9965 7.12541 22.112C7.21741 22.2268 7.3551 22.2934 7.50231 22.2934H18.2605C18.4077 22.2934 18.5454 22.2268 18.6374 22.112C18.7294 21.9971 18.763 21.8487 18.73 21.7034L17.5771 16.7085C17.4775 16.2783 17.1926 15.9978 16.8214 15.9566V14.6038C17.2059 14.56 17.506 14.2593 17.5822 13.8272L18.1285 10.7307L20.5631 8.63049C20.6697 8.53912 20.7306 8.40587 20.7306 8.26565V7.21172C20.7306 6.94586 20.5142 6.7295 20.249 6.7295ZM14.5048 21.3296H11.258L11.6653 16.9147H14.0974L14.5048 21.3296ZM5.16666 9.51691V12.2066C5.16666 12.3646 5.03849 12.4928 4.88049 12.4928C4.72249 12.4928 4.59369 12.3646 4.59369 12.2066V9.51691C4.59369 8.51184 5.41158 7.69396 6.41728 7.69396H7.09811L7.19963 8.26692H6.41728C5.72757 8.26692 5.16666 8.82783 5.16666 9.51691ZM12.1691 3.39069H13.421L13.2948 4.80883H12.296L12.1691 3.39069ZM17.6551 21.3296H15.4724L15.0644 16.9147H16.6355C16.6367 16.9178 16.6374 16.9217 16.638 16.9255L17.6551 21.3296ZM15.8576 14.6095V15.9509H9.90583V14.6095H15.8576ZM9.78718 6.72949L11.9566 5.77265H13.6368L15.8931 6.72949H9.78718ZM16.6361 13.6457H15.0619L15.4819 7.69394H17.6862L16.6361 13.6457ZM14.5162 7.69394L14.0962 13.6457H9.12665L8.07653 7.69394H14.5162ZM10.6983 16.9147L10.291 21.3296H8.10826L9.12475 16.9255C9.12538 16.9216 9.12665 16.9178 9.12729 16.9147H10.6983ZM19.7668 7.69394V8.04546L18.3931 9.23009L18.6646 7.69394H19.7668Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CoffeeMakerIcon;
